export default __webpack_public_path__ + "static/media/intro5.a7b69ecc.mp3";